import { makeStyles } from "tss-react/mui";

export interface IParams {
    isCompactLayout?: boolean;
}

export const useStyle = makeStyles<IParams>()((theme, props) => {
    const { isCompactLayout } = props;

    return {
        container: {
            display: "flex",
            flexDirection: "column",
            alignItems: isCompactLayout ? "center" : "flex-start",
            maxWidth: 1280,
            margin: 0,
            width: "100%",
        },
        card: {
            width: "100%",
            background: theme.palette.background.dark,
            boxShadow: "none",
        },
        cardHeader: {
            alignItems: "center",
        },
        cardContent: {
            display: "flex",
            flexDirection: isCompactLayout ? "column" : "row",
            gap: theme.spacing(2),
            justifyContent: isCompactLayout ? undefined : "space-between",
        },
        priceContainer: {
            display: "flex",
            flexDirection: isCompactLayout ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            gap: isCompactLayout ? theme.spacing(2) : theme.spacing(10),
            paddingRight: isCompactLayout ? theme.spacing(0) : theme.spacing(2),
        },
        button: {
            textWrap: "nowrap",
        },
    };
});
